import Clipboard from 'clipboard'
import { Toast } from 'vant'

export default function handleClipboard (text, event, tip = true) {
  const clipboard = new Clipboard(event.target, {
    text: () => text
  })
  clipboard.on('success', () => {
    if (tip) Toast('复制成功')
    clipboard.destroy()
  })
  clipboard.on('error', () => {
    Toast('复制失败')
    clipboard.destroy()
  })
  clipboard.onClick(event)
}
